import styled from 'styled-components';

import { ButtonFilled, Flex, Text } from '../Base';
import { ThankYouWithCriteriaProps } from './types';

const StyledSpcialRemarkText = styled((props) => (
  <Text
    textStyle="body1"
    color="text.darkText"
    textAlign="center"
    mt={6}
    px={2}
    width="100%"
    {...props}
  />
))`
  white-space: normal;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    white-space: pre-line;
  }
`;

const StyledSpecialMainText = styled((props) => (
  <Text
    mt={4}
    textStyle="subtitle1"
    color="text.darkText"
    textAlign="center"
    px={2}
    width="100%"
    {...props}
  />
))`
  white-space: normal;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    white-space: pre-line;
  }
`;

const ThankYouWithCriteria = (props: ThankYouWithCriteriaProps): JSX.Element => {
  const { imageUrl, email, remarkText = '', buttonDetails, customMainText } = props;

  return (
    <Flex
      maxWidth={'712px'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      p={2}
    >
      {imageUrl && (
        <img src={imageUrl} width={'100%'} style={{ maxWidth: '425px' }} alt={'Thank you'} />
      )}
      <Text mt={7} textStyle="heading3" color="text.darkText">
        ชำระเงินสำเร็จ!
      </Text>

      {customMainText ? (
        <StyledSpecialMainText dangerouslySetInnerHTML={{ __html: customMainText }} />
      ) : (
        <>
          <Text mt={4} textStyle="body1" textAlign="center" style={{ 'white-space': 'pre-line' }}>
            ดูหลักฐานการสั่งซื้อและรายละเอียดการจัดส่งได้ที่
          </Text>
          <Text
            textStyle="body1"
            fontWeight={600}
            textAlign="center"
            style={{ 'word-break': 'break-all' }}
          >
            {email}
          </Text>
        </>
      )}

      {remarkText && <StyledSpcialRemarkText dangerouslySetInnerHTML={{ __html: remarkText }} />}
      {buttonDetails?.url && (
        <ButtonFilled
          mt={'36px'}
          py={'6px'}
          px={6}
          onClick={() => {
            if (buttonDetails?.url) {
              window.open(buttonDetails.url, '_blank');
            }
          }}
        >
          <Text textStyle="body1Medium">{buttonDetails?.label}</Text>
        </ButtonFilled>
      )}
    </Flex>
  );
};

export { ThankYouWithCriteria };
